import { useMemo } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { db, type UploadQueueRow } from '@/db';

export interface UploadStats {
  total: number;
  ready: number;
  working: number;
  errors: number;
}

export function computeUploadStats(items: UploadQueueRow[]): UploadStats {
  let ready = 0;
  let working = 0;
  let errors = 0;
  for (const i of items) {
    if (i.status === 'done') ready += 1;
    else if (i.status === 'uploading' || i.status === 'queued') working += 1;
    else if (i.status === 'error') errors += 1;
  }
  return { total: items.length, ready, working, errors };
}

export function useUploadQueue(): UploadQueueRow[] {
  const data = useLiveQuery(() => db.uploadQueue.orderBy('createdAt').reverse().toArray());
  return useMemo(() => data ?? [], [data]);
}

export function useUploadStats(): UploadStats {
  const queue = useUploadQueue();
  return useMemo(() => computeUploadStats(queue), [queue]);
}
